import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';
import { getEvidenceIntegrations } from '@/pages/api/scribeAPIV2';
import { isEvidenceApiAvailable } from '@/utils/backendSurfaces';
import { useQuery } from '@tanstack/react-query';

export const GET_EVIDENCE_INTEGRATIONS = 'EvidenceIntegrations';

/**
 * Fetches available evidence integration partners.
 *
 * The backend resolves the user's region from the auth token and returns
 * all partners with `is_available` based on region + server configuration.
 *
 * `GET /v2/evidence/integrations` is part of ml-scribe's cloud-only evidence
 * aggregate, so the gate carries the surface term: the chat composer mounts
 * this read on every render of the source control, and on an on-prem build the
 * route does not exist. Disabled, `data` stays `undefined` and every consumer
 * already reads that as "no partners".
 */
export function useQueryEvidenceIntegrations() {
  const { isAuthenticated } = useIsAuthenticated();

  return useQuery({
    queryKey: [GET_EVIDENCE_INTEGRATIONS],
    enabled: isEvidenceApiAvailable && isAuthenticated,
    queryFn: async () => {
      const { data } = await getEvidenceIntegrations();
      return data;
    },
    staleTime: 5 * 60 * 1000,
  });
}
